import { render, staticRenderFns } from "./inspectionCategoryTable.vue?vue&type=template&id=6d335e1a"
import script from "./inspectionCategoryTable.vue?vue&type=script&lang=js"
export * from "./inspectionCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports